import actions from '../constants/actions';

const { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, BIZ_DATA, AUTH_ACCESS_TOKEN, REPORT_LIST_DETAIL } = actions;

const authInitState = {
  loginUserData: {},
  loading: false,
  error: null,
};

const bizInitState = {
  bizData: {},
  bizAccessToken: {},
  loading: false,
};

const reportInitState = {
  reportListDetail: {},
};

export const authReducer = (state = authInitState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginUserData: payload,
        error: null,
        loading: false,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loginUserData: {},
        error: payload,
        loading: false,
      };
    case LOGOUT:
      return {
        ...state,
        loginUserData: {},
        error: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const bizReducer = (state = bizInitState, action) => {
  const { type, payload } = action;
  switch (type) {
    case BIZ_DATA:
      return {
        ...state,
        bizData: payload,
        loading: false,
      };
    case AUTH_ACCESS_TOKEN:
      return {
        ...state,
        bizAccessToken: payload,
      };
    default:
      return state;
  }
};

export const reportReducer = (state = reportInitState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REPORT_LIST_DETAIL:
      return {
        ...state,
        reportListDetail: payload,
      };

    default:
      return state;
  }
};
